<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    max-width="1200px"
  >
    <v-card>
      <v-card-title>
        <span v-if="item.id">Cập nhật item#{{item.id}}</span>
        <span v-else>Danh mục chức năng</span>
        <v-spacer/>
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="close()"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-menu>
      </v-card-title>
      <v-divider/>
      <v-card-text>
        <v-container>
          <div v-if="errors_exist" class="row">
            <div class="col">
              <v-alert
                dense
                outlined
                type="error"
              >
                {{ $vuetify.lang.t('$vuetify.msg.hasError') }}
                <ul>
                  <div v-for="(error, index) in errors">
                    <li :key="index">{{ error[0] }}</li>
                  </div>
                </ul>
              </v-alert>
            </div>
          </div>
          <v-row>
            <v-col 
              cols="12" 
              sm="6"
              md="3"
              v-for="(perms, groupName) in permissions"
              :key="groupName"
            >
              <v-card height="100%">
                <v-toolbar
                  flat
                  color="primary"
                  dark
                  dense
                >
                  <v-toolbar-title>{{groupName}}</v-toolbar-title>
                </v-toolbar>
                <v-card-text class="blue lighten-5">
                  <div v-for="(perm, index) in perms"
                    :key="index">
                    <v-checkbox
                      v-model="permSelected"
                      :label="perm.name"
                      :value="perm.id"
                      hide-details="auto"
                    />
                  </div>
                </v-card-text>
                <v-divider/>
                <v-card-actions class="px-4">
                  <v-checkbox
                    label="Chọn hết"
                    hide-details="auto"
                    class="mt-0"
                    @change="checkAllChanged($event, perms)"
                  />
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="pink darken-1"
          text
          @click="close"
        >
          Hủy bỏ
        </v-btn>
        <v-btn
          color="primary darken-1"
          text
          @click="get(item)"
        >
          Thêm
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    props: {
      showDialog: {
        type: Boolean,
        default: false
      },
      item: []
    },
    data () {
      return {
        dialog: false,
        errors_exist: false,
        errors: [],
        permissions: [],
        permSelected: [],
        isAll: [],
      }
    },
    mounted() {
      this.dialog = this.showDialog;
    },
    watch: {
      showDialog() {
        const app=this;
        app.dialog = false;
        if (app.showDialog) {
          app.dialog = true;
          app.getPermissions();
          app.permSelected=[];
          if(app.item){
            app.item.forEach(function(v, i){
              app.permSelected.push(v);
            });
          }
        }
      }
    },
    methods: {
      getPermissions () {
        axios.get("api/v1/permissions")
          .then(response => {
            let group = response.data.reduce((r, a) => {
              if(a.group) {
                r[a.group.name] = [...r[a.group.name] || [], a];
              }
              return r;
            }, {});
            this.permissions = group;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      close() {
        this.dialog = false;
        this.$emit('cancelled');
      },
      checkAllChanged(val, list){
        const app=this;
        if(val) {
          list.forEach(function(v, i){
            app.permSelected.push(v.id);
          });
        } else {
          list.forEach(function(v, i){
            app.permSelected.shift(v);
          });
        }
      },
      get(item) {
        this.$emit('confirmed', this.permSelected);
        this.dialog = !this.dialog;
      }
    }
  }
</script>